import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { MRT_ColumnFiltersState, MRT_SortingState } from "mantine-react-table";

interface DownloadWithdraw {
  token: string;
  columnFilter: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
}

const downloadWithdrawCSV = async ({
  token,
  columnFilter,
  sorting,
}: DownloadWithdraw) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/download-pending-withdrawals-csv`,
      {
        columnFilters: columnFilter || [],
        sort: sorting || [],
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default downloadWithdrawCSV;
